export { useDeleteApplicationDoc } from './useDeleteApplicationDoc';
